import React from 'react';
import { cn } from '../../utils/lib/utils';

export function Surface({ className, ...props }) {
  return (
    <div
      className={cn(
        'bg-background border border-border rounded-lg shadow-sm',
        className
      )}
      {...props}
    />
  );
} 